export default "__VITE_ASSET__D9byfq5R__"